/**
 * Resolves HyperComply org_id for questionnaire exports.
 * Admin/backend JWTs omit organization_id; Library Requests rows may carry it on details.
 * Prefer the row, then the token claim.
 * @param {unknown} _isDocLibrary retained for call-site compatibility
 */
export function resolveQuestionnaireExportOrgId(_isDocLibrary, details, decoded) {
  const fromRow =
    details?.organizationId ??
    details?.OrganizationId ??
    details?.organization_id ??
    details?.hypercomply_org_id ??
    details?.hc_org_id ??
    details?.sponsor_hypercomply_org_id ??
    details?.sponsor_organization_id;
  const fromToken =
    decoded?.organization_id ??
    decoded?.org_id ??
    decoded?.OrganizationId ??
    decoded?.hypercomply_org_id;
  return fromRow ?? fromToken;
}
